
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 80 59","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M47.14 39.612a3.308 3.308 0 01-3.807-1.646 94130.51 94130.51 0 01-15.22-24.547 3.768 3.768 0 01.323-4.663 3.644 3.644 0 015.487.595c5.138 8.227 10.253 16.468 15.398 24.69a3.72 3.72 0 01-2.188 5.574M23.454 56.96c-6.3-2.234-12.589-4.5-18.867-6.798a3.388 3.388 0 01-1.56-5.807 3.026 3.026 0 013.43-.837c6.496 2.32 12.984 4.661 19.463 7.025a3.21 3.21 0 012.4 2.788 3.462 3.462 0 01-1.62 3.465c-.296.155-.455.265-.917.4-.656.193-2.018-.125-2.329-.235zm50.043-28.023a3.7 3.7 0 01-4.336-4.192l1.802-14.784c.21-1.715.398-3.434.638-5.143a3.8 3.8 0 012.85-2.939 3.292 3.292 0 013.38 1.564c.515.793.715 1.75.56 2.683-.61 4.93-1.21 9.858-1.805 14.784-.22 1.833-.415 3.67-.62 5.505a3.148 3.148 0 01-2.47 2.518","fill":"#414142","stroke":"#414142","stroke-width":"2"}})])
          )
        }
      }
    